export default "__VITE_ASSET__D5lA7olK__"